export default {
  no_results: {
    title: 'Sem resultados para «{{search}}»',
    desc: 'Lamentamos, não encontrámos correspondência. Por favor tente um termo de pesquisa diferente.',
  },
  empty_menu: {
    title: 'Ainda sem artigos disponíveis',
    desc: 'Este menu não tem nada para mostrar de momento. Por favor volte a verificar em breve.',
  },
};
